import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type AcceptTosMutationVariables = Types.Exact<{
  acceptanceId: Types.Scalars['Int']
  acceptEsign?: Types.InputMaybe<Types.Scalars['Boolean']>
}>

export type AcceptTosMutation = {
  __typename?: 'Mutation'
  acceptAgreement?: {
    __typename?: 'AcceptAgreementPayload'
    acceptance?: { __typename?: 'Acceptance'; id: number } | null
  } | null
}

export const AcceptTosDocument = `
    mutation acceptTos($acceptanceId: Int!, $acceptEsign: Boolean) {
  acceptAgreement(input: {acceptanceId: $acceptanceId, acceptEsign: $acceptEsign}) {
    acceptance {
      id
    }
  }
}
    `
export const useAcceptTosMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<AcceptTosMutation, TError, AcceptTosMutationVariables, TContext>
) =>
  useMutation<AcceptTosMutation, TError, AcceptTosMutationVariables, TContext>(
    ['acceptTos'],
    (variables?: AcceptTosMutationVariables) =>
      fetchGql<AcceptTosMutation, AcceptTosMutationVariables>(AcceptTosDocument, variables)(),
    options
  )
